module.exports = __webpack_public_path__ + "1.jpg?768427d608944e4ebd81b7c1bb304fcc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/1.jpg
// module id = 47
// module chunks = 0